import React from "react";
import { useBusyBlockerContext } from "../../contexts/busy-blocker-context";
import { useAppContext } from "../../hooks/useAppContext";
import { useErrorHandling } from "../../hooks/useErrorHandling";
import { useLabels } from "../../hooks/useLabels";
import { useNavigateToUrl } from "../../hooks/useNavigate";
import { showLeaveDialogAsync } from "../dialogs/leave-dialog";
import { showSaveAndConfirmDialogAsync } from "../dialogs/save-dialog";
import { FloatingMenuItem } from "./floating-menu-item";
import { labels } from "./labels";

export function MySavedProductsMenuItem() {
	const { createErrorHandler } = useErrorHandling();
	const navigateToUrl = useNavigateToUrl();
	const { busyBlocker } = useBusyBlockerContext();

	const {
		context: { account, mySavedProductsUrl },
		editor,
	} = useAppContext();
	const [[savedProducts], areLabelsLoading] = useLabels([labels.savedProducts]);

	function onMyProductsClick() {
		if (!editor.isDirty()) {
			navigateToUrl(mySavedProductsUrl);
		} else {
			showLeaveDialogAsync()
				.then((shouldLeave) =>
					shouldLeave
						? showSaveAndConfirmDialogAsync({
								isLeavingPage: true,
								editor,
								busyBlocker,
								getIsSignedIn: () =>
									account?.type === eXpress.core.AccountType.Full,
						  }).then((result) => result !== undefined)
						: false,
				)
				.then((shouldLeave) => {
					if (shouldLeave) navigateToUrl(mySavedProductsUrl);
				})
				.catch(createErrorHandler());
		}
	}

	if (areLabelsLoading || !mySavedProductsUrl) return null;

	return (
		<FloatingMenuItem
			text={savedProducts}
			iconName="shopping-bag-gift"
			onClick={onMyProductsClick}
		/>
	);
}
